
<template>
    <!-- 物资库存表 -->
    <div class="buttonlist">
      <div class="buttonlist-m">
        <el-form
          :inline="true"
          :model="filteForm"
          class="demo-form-inline toolbar"
          style="padding-bottom: 0px"
          @submit.native.prevent
        >
          <el-form-item label="物资仓库">
            <el-select
                v-model="filteForm.type"
                clearable>
                <el-option
                 v-for="item in typeList"
                 :key="item.id"
                 :label="item.name"
                 :value="item.name">
               </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物资名称" style="margin-left: 20px;">
            <el-input v-model.trim="filteForm.name" clearable auto-complete="off" placeholder=""></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              plain
              @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <div v-loading="loading" element-loading-text="拼命加载中......">
          <el-table
            :data="tableData"
            style="width: 100%"
            :row-style="tableRowStyle"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column prop="name" label="物资"  align=center></el-table-column>
            <el-table-column prop="type" label="仓库" align=center></el-table-column>
            <el-table-column prop="no" label="编号" align=center></el-table-column>
            <el-table-column prop="unit" label="单位" align=center></el-table-column>
            <el-table-column prop="norms" label="规格" align=center></el-table-column>
            <!-- <el-table-column prop="shopPrice" label="进货价" align=center></el-table-column>
            <el-table-column prop="salePrice" label="销售价" align=center></el-table-column> -->
            <!-- <el-table-column prop="lowerNum" label="数量预警" align=center></el-table-column>
            <el-table-column prop="period" label="到期预警" align=center></el-table-column> -->
            <el-table-column prop="number" label="库存数" align=center></el-table-column>
            <el-table-column prop="remark" label="备注" align=center></el-table-column>
          </el-table>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            layout="total, prev, pager, next"
            :total="totalDataNumber"
            :page-size="pageSize"
            align="center"
            class="fenye"
          ></el-pagination>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        pageNum: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber:0,
        loading:true,
        filteForm: {
          type: "",
          name:""
        },
        tableData:[],
        typeList:[],
      };
    },
    methods: {
      //点击查询
      onSubmit() {
        this.pageNum = 1;
        this.getTableData();
      },
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
        }
      },
      //获取分页的紧急按钮数据  只获取pageSize条数据
      getTableData() {
        let params = {
          groupId:this.groupId,
          pageSize:this.pageSize,
          pageNum:this.pageNum,
          type:this.filteForm.type,
          name:this.filteForm.name
        };
        this.loading = true;
        this.$postJson('mdc/storage/queryStockWithPage',params).then(res=>{
          if(res.code==200){
            this.totalDataNumber = Number(res.result.total)
            this.tableData = res.result.list;
          }
          this.loading = false;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getTableData();
      },
      getTypeList(){
        //typeList
        this.$postJson('mdc/storage/queryCategory',{
          groupId:this.groupId
        }).then(res=>{
          if(res.code==200){
            this.typeList = res.result;
          }
        })  
      }
    },
    mounted() {
      this.getTypeList();
      this.getTableData();
    },
    created(){
      this.groupId = sessionStorage.getItem("groupId");
    },
  };
  </script>
  <style lang="scss" scoped>
  .buttonlist {
    .buttonlist-m {
      padding: 10px 0 0 5px;
    }
  }
  .fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
  }
  </style>